import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {BreadCrumb} from "../bread-crumb";
import {Router} from "@angular/router";
import {BreadCrumbLocalStorageService} from "../bread-crumb-local-storage.service";
import {BreadCrumbLabel} from "../broad-crumb-label.enum";
import {InfoPageService} from "../../info-pages/info-page.service";
import {TranslateService} from '../../shared/translate.service';
import {UserQueryDtoInterface} from '../../auth/account/user-queries/dto/user-query-dto';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css']
})
export class BreadcrumbComponent implements OnInit, OnChanges {

  breadcrumbs$: BreadCrumb[] = [];

  @Input('breadcrumbs$') set _breadcrumbs$(values: BreadCrumb[]) {
    this.breadcrumbs$ = [];
    BreadcrumbComponent.filterDuplicatedBrowseLabels(values).forEach(b => {
      if (BreadCrumbLocalStorageService.isInfoPage(b.url)) {
        this.getLabel(b);
      }
      this.breadcrumbs$.push(b);
    });
  }

  userQueryDto: UserQueryDtoInterface;

  constructor(public router: Router, private breadCrumb: BreadCrumbLocalStorageService,
              private infoService: InfoPageService,
              public translateService: TranslateService) {
  }

  ngOnInit() {
    this.breadcrumbs$ = [];

    BreadcrumbComponent.filterDuplicatedBrowseLabels(this.breadCrumb.getBreadcrumbsArray()).forEach(b => {
      if (BreadCrumbLocalStorageService.isInfoPage(b.url)) {
        this.getLabel(b);
      }
      this.breadcrumbs$.push(b);
    });

    this.translateService.languageChanged.subscribe(lang => {
      this.ngOnChanges();
    });
    (document.querySelector('#background-bar-2') as HTMLElement).style.display = 'block';
  }

  ngOnChanges(): void {
    this._breadcrumbs$ = this.breadcrumbs$;
  }

  ngOnDestroy() {
    (document.querySelector('#background-bar-2') as HTMLElement).style.display = 'none';
  }

  preventDef(event) {
    if (event) {
      event.preventDefault();
    }
  }

  navigateTo(url: string) {
    this.router.navigateByUrl(url);
  }

  getLabel(breadCrumb: BreadCrumb): void {
    this.infoService.getInfoPageLabel(breadCrumb.url).subscribe(value => {
      breadCrumb.label = value;
    }, error1 => {
      console.error('Cannot load label for ' + breadCrumb.url + ', reason', error1);
      return '';
    });
  }

  private static filterDuplicatedBrowseLabels(values: BreadCrumb[]): BreadCrumb[] {
    if (values) {
      let result: BreadCrumb[] = [];
      let next: BreadCrumb = undefined;
      for (let i = values.length - 1; i >= 0; i--) {
        if (!next) {
          next = values[i];
          result.push(next);
        } else if (BreadcrumbComponent.isSearchOrBrowse(values[i])) {
          if (!BreadcrumbComponent.isSearchOrBrowse(next)) {
            result.push(values[i]);
            next = values[i];
          }
        } else if (!BreadcrumbComponent.isSearchOrBrowse(values[i])) {
          result.push(values[i]);
          next = values[i];
        }
      }
      return result.slice().reverse();
    } else {
      return values;
    }
  }

  private static isSearchOrBrowse(breadcrumb: BreadCrumb): boolean {
    if (breadcrumb) {
      return breadcrumb.label === BreadCrumbLabel.browse || breadcrumb.label === BreadCrumbLabel.search;
    }
    return false;
  }
}
